export const common = {
  nav: {
    home: 'Startseite',
    projects: 'Projekte',
    furniture: 'Möbel',
    news: 'Nachrichten',
    contact: 'Kontakt',
    aiAssistant: 'KI-Assistent',
    ar: 'AR-Erlebnis',
    exterior: 'Außenfassade',
    about: 'Über Uns'
  },
  hero: {
    title1: 'Die Geometrie der Natur',
    title2: 'Wiedergeboren in der Architektur',
    description: 'Maßgefertigtes Möbeldesign, Innenarchitekturberatung und Fertigbaulösungen mit amorphen Formen und natürlichen Materialien',
    exploreProjects: 'Projekte Erkunden',
    viewAR: 'Mit AR Ansehen',
    europeanStandards: 'Europäische Standards',
    globalDelivery: 'Globale Lieferung',
    arTechnology: 'AR-Technologie',
    customDesign: 'Maßgeschneidertes Design'
  },
  projects: {
    title: 'Ausgewählte Projekte',
    subtitle: 'Nach globalen Standards fertiggestellte Architektur- und Innenraumprojekte',
    viewDetails: 'Details Ansehen',
    istanbul: 'Istanbul, Türkei',
    dubai: 'Dubai, VAE',
    london: 'London, UK',
    paris: 'Paris, Frankreich',
    berlin: 'Berlin, Deutschland',
    miami: 'Miami, USA',
    project1: 'Luxusresidenz mit Bosporus-Blick',
    project2: 'Moderner Bürokomplex',
    project3: 'Minimalistisches Villendesign',
    project4: 'Kunstgalerie Innenraum',
    project5: 'Boutique-Hotel-Projekt',
    project6: 'Penthouse-Wohnung'
  },
  ar: {
    title: 'Sehen Sie Ihre Möbel mit Augmented Reality',
    subtitle: 'Erleben Sie Möbel vor dem Kauf in Ihrem eigenen Raum mit AR-Technologie',
    feature1Title: 'Ansicht in Originalgröße',
    feature1Desc: 'Sehen Sie Möbel in realen Dimensionen in Ihrem Raum',
    feature2Title: 'Sofortige Entscheidung',
    feature2Desc: 'Testen Sie sofort die Kompatibilität mit Ihrem Raum',
    feature3Title: 'Einfach zu Bedienen',
    feature3Desc: 'Erleben Sie AR in Sekunden mit Ihrem Telefon',
    tryNow: 'Jetzt Ausprobieren'
  },
  furniture: {
    title: 'Maßgefertigte Möbelkollektionen',
    subtitle: 'Einzigartige Stücke, entworfen mit natürlichen Materialien und amorphen Formen',
    organicTables: 'Organische Tische',
    organicTablesDesc: 'Kombination aus Naturholz und Harz',
    sculptural: 'Skulpturale Sitzmöbel',
    sculpturalDesc: 'Sessel in Kunstwerkqualität',
    lighting: 'Beleuchtung',
    lightingDesc: 'Handgefertigte Designerlampen',
    storage: 'Aufbewahrung',
    storageDesc: 'Funktionale Aufbewahrungslösungen',
    viewCollection: 'Kollektion Ansehen'
  },
  news: {
    title: 'Architektur- und Designnachrichten',
    subtitle: 'Aktuelle Nachrichten und Trends aus der globalen Architekturwelt',
    readMore: 'Mehr Lesen',
    news1Title: 'Neue Trends in der Nachhaltigen Architektur',
    news1Desc: 'Umweltfreundliche Materialien und energieeffiziente Designs transformieren die Architekturwelt',
    news2Title: 'Biophiles Design: Leben mit der Natur',
    news2Desc: 'Die Verwendung natürlicher Elemente in Innenräumen steigert Gesundheit und Wohlbefinden',
    news3Title: 'Smart Home Technologien 2025',
    news3Desc: 'KI-gestützte Haussysteme bringen Komfort und Sicherheit auf ein neues Level'
  },
  exterior: {
    title: 'Außenverkleidung',
    subtitle: 'Moderne und langlebige Fassadenlösungen',
    description: 'Ästhetische und funktionale Außenverkleidungssysteme nach europäischen Standards. Maßgeschneiderte Designanwendungen mit Naturstein, Holz und Verbundmaterialien.',
    learnMore: 'Mehr Erfahren',
    prefabTitle: 'Fertiggebäude',
    prefabSubtitle: 'Schnelle und qualitativ hochwertige Baulösungen',
    prefabDescription: 'Hochwertige Projekte in kurzer Zeit mit modularen und vorgefertigten Bausystemen. Energieeffizienz- und nachhaltigkeitsorientierte Lösungen.'
  },
  testimonials: {
    title: 'Kundenmeinungen',
    subtitle: 'Erfahrungen unserer globalen Kunden',
    client1: 'Ahmet Yılmaz',
    client1Title: 'Villenbesitzer, Istanbul',
    client1Text: 'Das Ernado-Team hat unser Traumhaus Wirklichkeit werden lassen. Natürliche Materialien und maßgefertigte Möbel sind fantastisch. Dank AR-Technologie konnten wir vor dem Kauf alles sehen.',
    client2: 'Ayşe Demir',
    client2Title: 'Hotelmanagerin, Antalya',
    client2Text: 'Die Zusammenarbeit mit Ernado für das Innendesign unseres Hotels war eine perfekte Erfahrung. Ihr professioneller Ansatz und die pünktliche Lieferung haben uns sehr zufrieden gestellt.',
    client3: 'Mehmet Kaya',
    client3Title: 'Architekt, Ankara',
    client3Text: 'Ernados Expertise und Qualität in unserem Fertigbauprojekt haben unsere Erwartungen übertroffen. Europäische Standard-Handwerkskunst und Materialqualität.',
    client4: 'Zeynep Arslan',
    client4Title: 'Innenarchitektin, Izmir',
    client4Text: 'Ernados Kreativität und Liebe zum Detail bei maßgefertigten Möbeldesigns ist bewundernswert. Jedes Stück ist wie ein Kunstwerk.',
    client5: 'Can Özdemir',
    client5Title: 'Restaurantbesitzer, Bodrum',
    client5Text: 'Wir haben mit Ernado für die Außenverkleidung und Innengestaltung unseres Restaurants zusammengearbeitet. Das Ergebnis ist großartig, unsere Kunden loben ständig den Raum.',
    client6: 'Elif Şahin',
    client6Title: 'Hausbesitzerin, Bursa',
    client6Text: 'Ernados Beratungsservice war sehr wertvoll bei der Renovierung meiner Wohnung. Amorphe Formen und natürliche Materialien gaben meinem Raum einen einzigartigen Charakter.'
  },
  footer: {
    description: 'Ein globales Designunternehmen, das maßgefertigtes Möbeldesign, Innenarchitekturberatung und Fertigbaulösungen mit natürlichen Materialien und amorphen Formen anbietet.',
    quickLinks: 'Schnelllinks',
    services: 'Unsere Dienstleistungen',
    interiorDesign: 'Innenarchitekturberatung',
    customFurniture: 'Maßgefertigtes Möbeldesign',
    exteriorCladding: 'Außenverkleidung',
    prefabBuildings: 'Fertiggebäude',
    contact: 'Kontakt',
    newsletter: 'Newsletter',
    newsletterText: 'Bleiben Sie über neue Projekte und Nachrichten informiert',
    emailPlaceholder: 'Ihre E-Mail-Adresse',
    subscribe: 'Abonnieren',
    rights: 'Alle Rechte vorbehalten.',
    phone: 'Telefon',
    email: 'E-Mail',
    address: 'Adresse',
    addressText: 'Nişantaşı, Istanbul, Türkei',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen'
  },
  privacy: {
    title: 'Datenschutzrichtlinie',
    intro: 'Bei ERNADO legen wir Wert auf die Sicherheit und den Schutz Ihrer persönlichen Daten. Diese Datenschutzrichtlinie erklärt, wie Informationen verwendet werden, die beim Besuch unserer Website gesammelt werden.',
    section1Title: 'Gesammelte Informationen',
    section1Text: 'Wenn Sie unsere Website besuchen, können Informationen wie Ihre IP-Adresse, Browsertyp, besuchte Seiten und Besuchsdauer automatisch erfasst werden. Darüber hinaus werden persönliche Informationen wie Name, E-Mail-Adresse und Telefonnummer gesammelt, die Sie freiwillig über Kontaktformulare bereitstellen.',
    section2Title: 'Verwendung von Informationen',
    section2Text: 'Die gesammelten Informationen werden verwendet, um unsere Dienstleistungen zu verbessern, auf Kundenanfragen zu reagieren, Marketingaktivitäten durchzuführen und unsere gesetzlichen Verpflichtungen zu erfüllen.',
    section3Title: 'Informationssicherheit',
    section3Text: 'Wir verwenden branchenübliche Sicherheitsmaßnahmen zum Schutz Ihrer persönlichen Daten. Bitte beachten Sie jedoch, dass keine Datenübertragung über das Internet zu 100% sicher ist.',
    section4Title: 'Weitergabe an Dritte',
    section4Text: 'Wir geben Ihre persönlichen Informationen nicht an Dritte weiter, außer wenn dies gesetzlich vorgeschrieben ist. Unsere Dienstleister können nur auf Informationen zugreifen, die zur Erbringung von Dienstleistungen in unserem Namen erforderlich sind.',
    section5Title: 'Cookies',
    section5Text: 'Unsere Website kann Cookies verwenden, um die Benutzererfahrung zu verbessern. Sie können Cookies über Ihre Browsereinstellungen verwalten oder ablehnen.',
    contact: 'Wenn Sie Fragen zu unserer Datenschutzrichtlinie haben, kontaktieren Sie uns bitte: ernado@outlook.com.tr'
  },
  terms: {
    title: 'Nutzungsbedingungen',
    intro: 'Durch die Nutzung der ERNADO-Website stimmen Sie den folgenden Nutzungsbedingungen zu. Bitte lesen Sie diese Bedingungen sorgfältig durch.',
    section1Title: 'Nutzung des Dienstes',
    section1Text: 'Unsere Website und Inhalte dürfen nur für rechtmäßige Zwecke verwendet werden. Bei der Nutzung unserer Website verpflichten Sie sich, Gesetze, Vorschriften und Rechte Dritter zu respektieren.',
    section2Title: 'Geistiges Eigentum',
    section2Text: 'Alle Inhalte, Designs, Logos, Bilder und Texte auf unserer Website sind Eigentum von ERNADO und durch Urheberrechtsgesetze geschützt. Unbefugte Nutzung, Vervielfältigung oder Verbreitung ist verboten.',
    section3Title: 'Haftungsausschluss',
    section3Text: 'Wir bemühen uns, die Richtigkeit der Informationen auf unserer Website sicherzustellen, garantieren jedoch nicht, dass die Informationen vollständig oder aktuell sind. ERNADO kann nicht für Schäden oder Verluste haftbar gemacht werden, die sich aus der Nutzung der Website ergeben.',
    section4Title: 'Links',
    section4Text: 'Unsere Website kann Links zu Websites Dritter enthalten. Diese Links werden nur zur Vereinfachung bereitgestellt, und ERNADO ist nicht verantwortlich für den Inhalt oder die Datenschutzpraktiken dieser Websites.',
    section5Title: 'Änderungen',
    section5Text: 'ERNADO behält sich das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Änderungen treten in Kraft, sobald sie auf der Website veröffentlicht werden.',
    section6Title: 'Kontakt',
    section6Text: 'Wenn Sie Fragen zu den Nutzungsbedingungen haben, kontaktieren Sie uns bitte: ernado@outlook.com.tr'
  }
};